module.exports = __webpack_public_path__ + "img/ru.3f756adc.png";